import { IBlockchainHandler } from './blockchainService';
import { networks, getNetworkById } from './blockchainConfig';

// Check if MetaMask is available
const isMetaMaskAvailable = () => {
  return typeof window !== 'undefined' && typeof window.ethereum !== 'undefined';
};

// Mock handler implementation
const mockHandler: IBlockchainHandler = {
  getWalletAddress: async () => {
    return '0x1234...mock...5678';
  },
  getBalance: async (stablecoin) => {
    console.log(`[MOCK] Fetching ${stablecoin.symbol} balance...`);
    return Math.random() * 10000;
  },
  sendTransaction: async (to, amount, stablecoin) => {
    console.log(`[MOCK] Sending ${amount} ${stablecoin.symbol} to ${to}`);
    return `0x${[...Array(64)].map(() => Math.floor(Math.random() * 16).toString(16)).join('')}`;
  }
};

// Initialize Web3 provider with error handling
export const initializeWeb3 = async (): Promise<IBlockchainHandler> => {
  try {
    // If MetaMask is not available, use our mock provider
    if (!isMetaMaskAvailable()) {
      console.debug('MetaMask not available, using mock provider');
      return mockHandler;
    }

    // If MetaMask is available but we're not using it, return mock provider
    // You can modify this condition based on your needs
    if (process.env.REACT_APP_USE_MOCK_PROVIDER === 'true') {
      console.debug('Using mock provider as configured');
      return mockHandler;
    }

    // If we want to use MetaMask, we can implement real provider here
    // For now, return mock provider
    return mockHandler;
  } catch (error) {
    console.debug('Error initializing Web3, falling back to mock provider:', error);
    return mockHandler;
  }
};

// Export a singleton instance
export const web3Provider = {
  initialize: initializeWeb3,
  // Add other Web3-related methods here
};
